import React, { useState, useEffect } from 'react';
import Header from '../../components/global/Header';
import { Box, Button, Paper, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import PeopleAlt from '@mui/icons-material/PeopleAlt';
import WorkIcon from '@mui/icons-material/Work';
import DeleteIcon from '@mui/icons-material/Delete';
import Colors from '../../Constant/Colors';
import client from '../../API/client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function UserInformation() {
  const [usersdata, setUsersData] = useState([]);
  const [ids, setIds] = useState([]);

  useEffect(() => {
    getUsersData();
  }, []);

  const deleteUsers = async () => {
    console.log(ids);
    const payload = { ids };
    await client
      .post(`/admin/delete-user`, payload)
      .then((res) => {
        if (res.status === 200) {
          toast.success('User Deleted Sucessfully', {
            position: toast.POSITION.TOP_CENTER,
          });
          getUsersData();
        } else {
          toast.error('OOps!! Something went wrong ', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((err) => {
        toast.error('OOps!! Something went wrong ', {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  const getUsersData = async () => {
    client
      .get('/admin/users-information', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(async (res) => {
        setUsersData(res.data);
        console.log(usersdata);
      });
  };
  const getRowId = (usersdata) => usersdata.user_id;

  const columns = [
    { field: 'user_id', headerName: 'ID', hide: true },

    {
      field: 'user_name',
      headerName: 'User Name',
      flex: 1,
      cellClassName: 'name-column--cell',
    },
    {
      field: 'user_email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'user_password',
      headerName: 'User Password',
      flex: 1,
    },
    {
      field: 'user_role',
      headerName: 'User Role',
      headerAlign: 'center',
      // align: "left",
      flex: 1,
      renderCell: ({ row: { user_role } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            backgroundColor={
              user_role === 'designer'
                ? '#CBF1F5'
                : user_role === 'recruiter'
                ? '#A6E3E9'
                : '#71C9CE'
            }
            borderRadius="4px">
            {user_role === 'designer' && <PeopleAlt sx={{ color: 'black' }} />}
            {user_role === 'recruiter' && <WorkIcon />}
            {user_role === 'admin' && <AdminPanelSettingsOutlinedIcon />}
            <Typography color={'black'} sx={{ ml: '5px' }}>
              {user_role}
            </Typography>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <Box m="20px">
        <ToastContainer />
        <Header
          title="Users Information Page"
          subtitle={'Users Information '}
        />
        <Button
          onClick={() => deleteUsers()}
          variant="contained"
          sx={{ marginTop: '20px', marginLeft: '5px', letterSpacing: 2 }}>
          <DeleteIcon sx={{ marginRight: '5px' }} />
          Delete
        </Button>
        <Paper elevation={5}>
          <Box
            m="20px 0 0 0"
            height="75vh"
            sx={{
              '& .MuiDataGrid-root': {
                border: '1px solid grey',
              },
              '& .MuiDataGrid-cell': {
                color: 'black',
                borderBottom: '1px solid gray',
              },
              '& .name-column--cell': {
                color: 'black',
              },
              '& .MuiDataGrid-columnHeaders': {
                color: 'black',
                borderBottom: 'none',
              },
              '& .MuiDataGrid-virtualScroller': {
                backgroundColor: 'white',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: 'none',
              },
              '& .MuiCheckbox-root': {
                color: `${'black'} !important`,
              },
            }}>
            <DataGrid
              checkboxSelection
              rows={usersdata}
              getRowId={getRowId}
              disableSelectionOnClick
              columns={columns}
              onSelectionModelChange={(data) => {
                setIds(data);
              }}
            />
          </Box>
        </Paper>
      </Box>
    </>
  );
}

export default UserInformation;
